import { render, staticRenderFns } from "./Mesas.vue?vue&type=template&id=38d8a107&"
import script from "./Mesas.vue?vue&type=script&lang=js&"
export * from "./Mesas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports